document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.florss-header-shell');
  const hero = document.querySelector('.florss-hero-motion');
  const revealItems = document.querySelectorAll('.florss-reveal');

  let lastY = window.scrollY;

  const updateHeader = () => {
    if (!header) return;
    const y = window.scrollY;

    if (y > 8) {
      header.classList.add('is-scrolled');
    } else {
      header.classList.remove('is-scrolled');
    }

    if (y > lastY && y > 180) {
      header.classList.add('is-hidden');
    } else {
      header.classList.remove('is-hidden');
    }

    lastY = y;
  };

  const reveal = (el) => {
    el.classList.add('is-visible');
  };

  if (hero) {
    requestAnimationFrame(() => {
      hero.classList.add('is-visible');
    });
  }

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          reveal(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });

    revealItems.forEach((item) => observer.observe(item));
  } else {
    revealItems.forEach(reveal);
  }

  updateHeader();
  window.addEventListener('scroll', updateHeader, { passive: true });
});